import React, { FC } from "react";
import RouterIndex from "./route-module/route-configuration/configuration-route/routeConfiguration";
import { AppShellProvider } from "./context-module/context-configuration/auth-provider/appShell/appShellProvider";
import { ToastProvider } from "./context-module/context-configuration/toast-provider/bottomToast/ts/ToastProvider";
import { CmsGlobalsProvider } from "./context-module/context-configuration/auth-provider/appShell/appShellGlobal/appUseGlData";
import { LoadingAniProvider } from "./context-module/context-configuration/auth-provider/loadinAni/LoadingAniProvider";

const App: FC = () => {

  return (
    <AppShellProvider>
      <CmsGlobalsProvider>
        <ToastProvider>
          <LoadingAniProvider>
            <RouterIndex />
          </LoadingAniProvider>
        </ToastProvider>
      </CmsGlobalsProvider>
    </AppShellProvider>
  );
};

export default App;
